import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { AvatarColor } from '../../avatar';
import { FlexBox } from '../../box';
import { getIcon } from '../../icon';
import { sentence } from '../../typography';
const isAutocompleteOption = (option) => Boolean(option &&
    Object.prototype.hasOwnProperty.call(option, 'label'));
const getDefaultOptionLabel = (option) => {
    if (isAutocompleteOption(option)) {
        return option.label;
    }
    if (typeof option === 'string' || typeof option === 'number') {
        return String(option);
    }
    throw new Error('[Autocomplete] Unsupported option type. Please provide `getOptionLabel` or use a AutocompleteOption | string | number as option');
};
const formatOptionLabel = (label, sentenceOptions) => (sentenceOptions ? sentence(label) : label);
// NOTE: workaround to visually fix the focused state
const liPropsExtension = {
    onMouseEnter: (e) => {
        const target = e.target;
        if (target.getAttribute('role') === 'option') {
            target.classList.add('Mui-focused');
        }
        else {
            target.closest('[role="option"]')?.classList.add('Mui-focused');
        }
    },
    onMouseLeave: (e) => {
        const target = e.target;
        if (target.getAttribute('role') === 'option') {
            target.classList.remove('Mui-focused');
        }
        else {
            target.closest('[role="option"]')?.classList.remove('Mui-focused');
        }
    }
};
function renderOption(props) {
    if (process.env.NODE_ENV === 'development') {
        if (props.renderOption &&
            (props.getOptionColor || props.getOptionIcon)) {
            console.warn('[Autocomplete] `props.renderOption` will be overridden when providing `getOptionColor` or `getOptionIcon`');
        }
        if (props.getOptionColor && props.getOptionIcon) {
            throw new Error('[Autocomplete] Cannot provide both `getOptionColor` and `getOptionIcon`');
        }
    }
    if (props.getOptionColor) {
        return (liProps, option) => {
            const extendedLiProps = {
                ...liPropsExtension,
                ...liProps
            };
            const label = props.getOptionLabel?.(option) ?? getDefaultOptionLabel(option);
            return (_jsxs(FlexBox, { gap: 2, ...extendedLiProps, children: [_jsx(AvatarColor, { color: props.getOptionColor?.(option) }), _jsx("span", { children: formatOptionLabel(label, props.sentenceOptions) })] }));
        };
    }
    if (props.getOptionIcon) {
        return (liProps, option) => {
            const extendedLiProps = {
                ...liPropsExtension,
                ...liProps
            };
            const label = props.getOptionLabel?.(option) ?? getDefaultOptionLabel(option);
            const { icon, iconProps } = props.getOptionIcon(option);
            const Icon = getIcon(icon);
            return (_jsxs(FlexBox, { gap: 2, ...extendedLiProps, children: [_jsx(Icon, { ...iconProps }), _jsx("span", { children: formatOptionLabel(label, props.sentenceOptions) })] }));
        };
    }
    return (liProps, option, ...args) => {
        const extendedLiProps = {
            ...liPropsExtension,
            ...liProps
        };
        const label = props.getOptionLabel?.(option) ?? getDefaultOptionLabel(option);
        return (props.renderOption?.(extendedLiProps, option, ...args) ?? (
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        _jsx(FlexBox, { ...extendedLiProps, children: formatOptionLabel(label, props.sentenceOptions) })));
    };
}
export default { renderOption };
